import { encryptTransform } from "redux-persist-transform-encrypt";

export const storeEncryptor = encryptTransform({
    secretKey: 'your-secret-key', // Replace this with a strong secret key
    onError: function(error) {
      // Handle the error.
      console.error('State encryption failed:', error);
    },
});
